import { Container, Card } from "reactstrap";
import { useRouter } from "next/router";
import useFocusValues from "@/hooks/useFocusValues";
import styles from "./styles.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

export const FocusValuesSlider = ({ data = [], className, bgColor }) => {
  const { asPath } = useRouter();
  const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

  const items = useFocusValues({ locale });

  if (!items || !items.length > 0) {
    return null;
  }

  const finalItems = data?.length > 1 ? data : items;

  const settings = {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: false,
    spaceBetween: 30,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.focusValuesSwiper.swiper-custom-paginations`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <section
      className={`${styles.root} ${className} pt-5 pb-4 ${bgColor} text-center`}
    >
      <Container>
        <Swiper {...settings}>
          {finalItems.map((item, index) => (
            <SwiperSlide key={index}>
              <Card className="border-0 bg-transparent d-block mt-3">
                <h3 className="fs-1">{item?.title}</h3>
                <div dangerouslySetInnerHTML={{ __html: item?.content }} />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="text-center mt-4">
          <div className={`focusValuesSwiper swiper-custom-paginations`} />
        </div>
      </Container>
    </section>
  );
};

export default FocusValuesSlider;
